// extracted by extract-css-chunks-webpack-plugin
module.exports = {"merchants-title":"event-time-dialog__merchants-title___77VFp","merchantsTitle":"event-time-dialog__merchants-title___77VFp","payment-batches-title":"event-time-dialog__payment-batches-title___1LyVh","paymentBatchesTitle":"event-time-dialog__payment-batches-title___1LyVh","batch-listing-text":"event-time-dialog__batch-listing-text___2CqaY","batchListingText":"event-time-dialog__batch-listing-text___2CqaY"};
    if(module.hot) {
      // 1701907094744
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  